import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  Button,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import { resetPassword } from "../../api/user";
import { Icon } from "../../components/Component";
import { ResetUserPasswordSchema } from "../../validations/UserValidation";

const PasswordField = ({ id, label, register, error, toggle, visible }) => (
  <div className="form-group">
    <Label htmlFor={id}>{label}</Label>
    <div className="form-control-wrap">
      <a
        href="#password"
        onClick={toggle}
        className={`form-icon form-icon-right passcode-switch ${
          visible ? "is-hidden" : "is-shown"
        }`}
      >
        <Icon name="eye" className="passcode-icon icon-show" />
        <Icon name="eye-off" className="passcode-icon icon-hide" />
      </a>
      <input
        type={visible ? "text" : "password"}
        id={id}
        {...register(id, {
          setValueAs: (value) => value.trim(),
        })}
        placeholder={`Enter your ${label.toLowerCase()}`}
        className={`form-control ${error ? "error" : ""}`}
      />
      {error && <span className="custom-invalid">{error.message}</span>}
    </div>
  </div>
);

const UserPasswordChange = ({ modalForm, setModalForm, userData }) => {
  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState({
    current: false,
    new: false,
    confirm: false,
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(ResetUserPasswordSchema),
  });

  useEffect(() => {
    reset({
      newPassword: "",
      confirmPassword: "",
    });
  }, [modalForm]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await resetPassword({
        id: userData.id,
        newPassword: data.newPassword,
        confirmNewPassword: data.confirmPassword,
      });
      if (response) {
        toast.success("Password changed successfully", {
          position: "top-center",
        });
        setModalForm(false);
        reset({
          newPassword: "",
          confirmPassword: "",
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-center",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={modalForm}>
      <ModalHeader
        toggle={() => setModalForm(!modalForm)}
        close={
          <button
            className="close"
            onClick={() => setModalForm(!modalForm)}
            aria-label="Close"
          >
            {/* <Icon name="cross" /> */}
          </button>
        }
      >
        Reset Password
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit(onSubmit)}>
          <PasswordField
            id="newPassword"
            label="New Password"
            register={register}
            error={errors.newPassword}
            toggle={() => setPassState({ ...passState, new: !passState.new })}
            visible={passState.new}
          />
          <PasswordField
            id="confirmPassword"
            label="Confirm New Password"
            register={register}
            error={errors.confirmPassword}
            toggle={() =>
              setPassState({ ...passState, confirm: !passState.confirm })
            }
            visible={passState.confirm}
          />
          <p className=" text-danger ">
            Note: User will be logged out after password reset.
          </p>

          <Row className="justify-content-end mx-auto">
            <Col className="col-auto px-0">
              <div className="form-group  pt-3">
                <Button
                  color="white"
                  onClick={() => setModalForm(false)}
                  size="lg"
                  disabled={loading}
                >
                  Cancel
                </Button>
              </div>
            </Col>
            <Col className="col-auto px-0">
              <div className="form-group  pt-3">
                <Button
                  color="primary"
                  type="submit"
                  size="lg"
                  disabled={loading}
                >
                  {loading ? (
                    <Spinner color="light" size="sm" />
                  ) : (
                    "Reset Password"
                  )}
                </Button>
              </div>
            </Col>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default UserPasswordChange;
